<template>
  <div class="visitors">
    <div v-if="sourceIsH5" class="navBar-wrap">
      <NavBar :narBarTitle="$t('邀约历史')" />
    </div>
    <van-tabs v-model="activeName" color="#3972FF" title-active-color="#3972FF">
      <van-tab :title="$t('待审批')" name="approval">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          class="infoBox"
          :style="{ height: height - 10 + 'px' }"
        >
          <van-list
            v-model="approvalLoading"
            :finished="approvalFinished"
            @load="onLoad"
            class="list-box"
          >
            <template v-if="!approvalList || approvalList.length === 0">
              <div class="empty">
                <div class="empty-box">
                  <img
                    class="empty-box-img"
                    src="@/assets/images/newEmpty.png"
                  />
                  <p class="empty-box-text">{{ $t('暂无内容') }}</p>
                </div>
              </div>
            </template>
            <div
              v-else
              :style="{ minHeight: height - 102 + 'px' }"
              class="card-box"
            >
              <Card
                v-for="item in approvalList"
                :key="item.id + '_' + Math.random()"
                :visitorName="item.visitorName"
                :purpose="I18nTemplateForRender(item.visitPurpose)"
                :intervieweeName="item.intervieweeName"
                :visitorTime="formatVisitTime(item)"
                :click="toInfo"
                :cancel="cancel"
                :visitorId="item.id"
                :companyName="item.visitorCompany"
                :data="item"
                :isApproval="item.isApproval"
                :checkRepeat="checkRepeat"
                :onRefuse="onRefuse"
                :auditStaffName="getAuditStaffName(item)"
              />
            </div>
            <div
              class="bottom"
              v-show="showPreBottom && approvalList.length !== 0"
            >
              <div></div>
              <span>{{ $t('到底啦') }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="$t('预接待')" name="pre">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          class="infoBox"
          :style="{ height: height - 10 + 'px' }"
        >
          <van-list
            v-model="preLoading"
            :finished="preFinished"
            @load="onLoad"
            class="list-box"
          >
            <template v-if="preList.length === 0 && !preLoading">
              <div class="empty">
                <div class="empty-box">
                  <img
                    class="empty-box-img"
                    src="@/assets/images/newEmpty.png"
                  />
                  <p class="empty-box-text">{{ $t('暂无内容') }}</p>
                </div>
              </div>
            </template>
            <div
              v-else
              :style="{ minHeight: height - 102 + 'px' }"
              class="card-box"
            >
              <Card
                v-for="item in preList"
                :key="item.id"
                :visitorName="item.visitorName"
                :purpose="I18nTemplateForRender(item.visitPurpose)"
                :intervieweeName="item.intervieweeName"
                :visitorTime="formatVisitTime(item)"
                :click="toInfo"
                :cancel="cancel"
                :visitorId="item.id"
                :stateMSG="$t('取消预约')"
                :companyName="item.visitorCompany"
              />
            </div>
            <div class="bottom" v-show="showPreBottom && preList.length !== 0">
              <div></div>
              <span>{{ $t('到底啦') }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="$t('接待中')" name="in">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          class="infoBox"
          :style="{ height: height - 10 + 'px' }"
        >
          <van-list
            v-model="inLoading"
            :finished="inFinished"
            @load="onLoad"
            class="list-box"
          >
            <template v-if="inList.length === 0 && !inLoading">
              <div class="empty">
                <div class="empty-box">
                  <img
                    class="empty-box-img"
                    src="@/assets/images/newEmpty.png"
                  />
                  <p class="empty-box-text">{{ $t('暂无内容') }}</p>
                </div>
              </div>
            </template>
            <div
              v-else
              :style="{ minHeight: height - 102 + 'px' }"
              class="card-box"
            >
              <Card
                v-for="item in inList"
                :key="item.id"
                :visitorName="item.visitorName"
                :purpose="I18nTemplateForRender(item.visitPurpose)"
                :visitorTime="formatVisitTime(item)"
                :companyName="item.visitorCompany"
                :registerTime="item.registerTime"
                :visitTime="item.visitTime"
                :visitEndTime="item.finishTime || item.visitEndTime"
                :finishTime="item.finishTime"
                :onEarlyEnd="handleEarlyEnd"
                :open="$t('开门')"
                :click="toInfo"
                :visitorId="item.id"
                :clickOpen="openDoor"
                :registerRobot="item.registerRobot"
              />
            </div>
            <div class="bottom" v-show="showInBottom && inList.length !== 0">
              <div></div>
              <span>{{ $t('到底啦') }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="$t('已完成')" name="completed" class="tab-box">
        <div class="timeRangeBox">
          <img src="@/assets/images/date.svg" alt="" class="date-icon" />
          <span @click="startDateShow = true">{{
            startDate ? dayjs(startDate).format('YYYY-MM-DD') : $t('选择日期')
          }}</span>
          <span class="swap-icon">-</span>
          <span @click="endDateShow = true">{{
            endDate ? dayjs(endDate).format('YYYY-MM-DD') : $t('选择日期')
          }}</span>
        </div>
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          class="infoBox"
          :style="{ height: height - 50 + 'px' }"
        >
          <van-list
            v-model="comLoading"
            :finished="comFinished"
            @load="onLoad"
            class="list-box"
          >
            <template v-if="completedList.length === 0 && !comLoading">
              <div class="empty-box">
                <img class="empty-box-img" src="@/assets/images/newEmpty.png" />
                <p class="empty-box-text">{{ $t('暂无内容') }}</p>
              </div>
            </template>
            <div
              v-else
              :style="{ minHeight: height - 142 + 'px' }"
              class="card-box"
            >
              <Card
                v-for="item in completedList"
                :key="item.id"
                :visitorName="item.visitorName"
                :purpose="I18nTemplateForRender(item.visitPurpose)"
                :visitorTime="formatVisitTime(item)"
                :companyName="item.visitorCompany"
                :click="toInfo"
                :visitorId="item.id"
              />
            </div>
            <div
              class="bottom"
              v-show="showComBottom && completedList.length !== 0"
            >
              <div></div>
              <span>{{ $t('到底啦') }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="$t('已取消')" name="cancel">
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
          class="infoBox"
          :style="{ height: height - 10 + 'px' }"
        >
          <van-list
            v-model="canLoading"
            :finished="canFinished"
            @load="onLoad"
            class="list-box"
          >
            <template v-if="cancelList.length === 0 && !canLoading">
              <div class="empty">
                <div class="empty-box">
                  <img
                    class="empty-box-img"
                    src="@/assets/images/newEmpty.png"
                  />
                  <p class="empty-box-text">{{ $t('暂无内容') }}</p>
                </div>
              </div>
            </template>
            <div
              v-else
              :style="{ minHeight: height - 102 + 'px' }"
              class="card-box"
            >
              <Card
                v-for="item in cancelList"
                :key="item.id"
                :visitorName="item.visitorName"
                :purpose="I18nTemplateForRender(item.visitPurpose)"
                :visitorTime="formatVisitTime(item)"
                :companyName="item.visitorCompany"
                :click="toInfo"
                :visitorId="item.id"
              />
            </div>
            <div
              class="bottom"
              v-show="showCanBottom && cancelList.length !== 0"
            >
              <div></div>
              <span>{{ $t('到底啦') }}</span>
              <div></div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <van-calendar
      v-model="startDateShow"
      @confirm="confirmStartDate"
      :title="$t('日期筛选')"
      color="#009BFF"
      :min-date="minDate"
      :formatter="formatter"
      type="range"
    />
  </div>
</template>
<script>
import {
  queryVisit,
  updateCancel,
  sendRobotMqtt,
  queryVisitAuditData,
  visitAudit,
  visitEndEarly,
} from '@/services/api'
import dayjs from 'dayjs'
import NavBar from '@/components/newNavBar'
import Card from '@/components/card'
import Vue from 'vue'
import  { I18nTemplateForRender } from 'i18n'

import { Tab, Tabs, Calendar, Toast, List, PullRefresh, Dialog } from 'vant'
Vue.use(Calendar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(Toast)
Vue.use(PullRefresh)
Vue.use(Dialog)

export default {
  name: 'Visitors',
  components: {
    NavBar,
    Card,
  },
  data() {
    return {
      user: {},
      activeName: '',
      startDateShow: false,
      endDateShow: false,
      showPreBottom: false,
      showApprovalBottom: false,
      showInBottom: false,
      showComBottom: false,
      showCanBottom: false,
      approvalLoading: false,
      preLoading: false,
      inLoading: false,
      isLoading: false,
      comLoading: false,
      canLoading: false,
      preFinished: false,
      approvalFinished: false,
      inFinished: false,
      comFinished: false,
      canFinished: false,
      startDate: '',
      endDate: '',
      minDate: new Date(2021, 0, 1),
      preList: [],
      approvalList: [],
      inList: [],
      completedList: [],
      cancelList: [],
      approvalPage: 0,
      prePage: 0,
      inPage: 0,
      comPage: 0,
      canPage: 0,
      height: '',
      sourceIsH5: true,
      approvalLoading: false, //审批按钮加载状态
    }
  },
  methods: {
    I18nTemplateForRender(payload) {
      // 可在此处做一层安全包装或兼容性处理
      try {
        return I18nTemplateForRender(payload)
      } catch (e) {
        // 出错时返回原始值，避免页面崩溃
        console.warn('I18nTemplateForRender error:', e)
        return payload
      }
    },
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    async confirmStartDate(date) {
      this.startDate = date[0]
      this.endDate = date[1]
      this.comPage = 1
      const res = await queryVisit({
        companyId: this.user.companyId,
        staffId: this.user.id,
        status: 'completed',
        page: this.comPage,
        startTime: dayjs(this.startDate).format('YYYY-MM-DD'),
        endTime: dayjs(this.endDate).format('YYYY-MM-DD'),
      })
      this.completedList = [...res.results]
      this.startDateShow = false
    },
    // selectTab(name) {
    //   this.getVisitors(this.user.companyId, this.user.id, name, 1)
    // },
    onConfirmEndDate(date) {
      this.endDate = date
      this.endDateShow = false
    },
    isApproval(data, id) {
      if (data.shareId) {
        if (data.auditProcess == 0 && id == data.interviewee) {
          return 1
        } else if (
          data.auditProcess == 1 &&
          data.auditStaffId?.split(',').includes(id + '')
        ) {
          return 1
        }
      } else {
        if (data.auditStaffId?.split(',').includes(id + '')) {
          return 1
        }
      }
      return 2
    },
    getAuditStaffName(data) {
      if (data.shareId) {
        if (data.auditProcess == 0) {
          return data.intervieweeName
        } else if (data.auditProcess == 1) {
          return data.auditStaffName
        }
      } else {
        return data.auditStaffName
      }
    },
    onLoad() {
      let page = 0
      let startTime = ''
      let endTime = ''
      switch (this.activeName) {
        case 'approval':
          this.approvalPage++
          page = this.approvalPage
          this.getVisitAuditData({
            companyId: this.user.companyId,
            staffId: this.user.id,
            page,
            pageSize: 10,
          })
          break
        case 'pre':
          this.prePage++
          page = this.prePage
          this.x(
            this.user.companyId,
            this.user.id,
            this.activeName,
            page,
            startTime,
            endTime
          )
          break
        case 'in':
          this.inPage++
          page = this.inPage
          this.x(
            this.user.companyId,
            this.user.id,
            this.activeName,
            page,
            startTime,
            endTime
          )
          break
        case 'completed':
          this.comPage++
          page = this.comPage
          this.startDate &&
            (startTime = dayjs(this.startDate).format('YYYY-MM-DD'))
          this.endDate && (endTime = dayjs(this.endDate).format('YYYY-MM-DD'))
          this.x(
            this.user.companyId,
            this.user.id,
            this.activeName,
            page,
            startTime,
            endTime
          )
          break
        case 'cancel':
          this.canPage++
          page = this.canPage
          this.x(
            this.user.companyId,
            this.user.id,
            this.activeName,
            page,
            startTime,
            endTime
          )
          break
      }
    },
    toInfo(id) {
      this.$store.state.visitorState = this.activeName
      this.$router.push(`/visitorInfo/${id}`)
    },
    async x(companyId, staffId, status, page, startTime, endTime) {
      const res = await queryVisit({
        companyId,
        staffId,
        status: status === 'cancel' ? 'cancel,refuse' : status,
        page,
        pageSize: 10,
        endTime,
        startTime,
      })
      let tmpArr = res.results
      switch (status) {
        case 'pre':
          this.preList = [...this.preList, ...tmpArr]
          if (tmpArr.length < 10) {
            this.showPreBottom = true
            this.preFinished = true
          } else {
            this.showPreBottom = false
          }
          this.preLoading = false
          break
        case 'in':
          this.inList = [...this.inList, ...tmpArr]
          if (tmpArr.length < 10) {
            this.showInBottom = true
            this.inFinished = true
          } else {
            this.showInBottom = false
          }
          this.inLoading = false
          break
        case 'completed':
          this.completedList = [...this.completedList, ...tmpArr]
          if (tmpArr.length < 10) {
            this.showComBottom = true
            this.comFinished = true
          } else {
            this.showComBottom = false
          }
          this.comLoading = false
          break
        case 'cancel':
          this.cancelList = [...this.cancelList, ...tmpArr]
          if (tmpArr.length < 10) {
            this.showCanBottom = true
            this.canFinished = true
          } else {
            this.showCanBottom = false
          }
          this.canLoading = false
          break
      }
    },
    async getVisitAuditData(data) {
      const res = await queryVisitAuditData(data)
      let tmpArr = res.results

      this.approvalList =
        ([...this.approvalList, ...tmpArr].length > 0 &&
          [...this.approvalList, ...tmpArr].map((item) => ({
            ...item,
            isApproval: this.user ? this.isApproval(item, this.user.id) : false,
          }))) ||
        []

      if (tmpArr.length < 10) {
        this.showApprovalBottom = true
        this.approvalFinished = true
      } else {
        this.showApprovalBottom = false
      }
      this.approvalLoading = false
    },
    async cancel(id) {
      try {
        await updateCancel({ id })
        Toast.success(this.$t('取消成功'))
        this.$router.go(0)
      } catch (error) {
        Toast.fail(error.response.data)
      }
    },
    async openDoor(serial) {
      const topic = `newbest/remoteControl/openDoor/${serial}`
      const data = {
        payload: JSON.stringify({
          staffId: this.user?.id,
          staffName: this.user?.name,
        }),
        topic: topic,
      }
      try {
        const res = await sendRobotMqtt(data)
        console.log(res, '远程开门成功')
      } catch (err) {
        console.log('远程开门失败', err)
      }
    },
    //下拉刷新
    async onRefresh() {
      let startTime = ''
      let endTime = ''
      switch (this.activeName) {
        case 'approval':
          this.approvalPage = 1
          const res = await queryVisitAuditData({
            companyId: this.user.companyId,
            staffId: this.user.id,
            page: 1,
            pageSize: 10,
          })
          let tmpArr = res.results
          this.approvalList = []
          this.approvalList =
            [...tmpArr] &&
            [...tmpArr].map((item) => ({
              ...item,
              isApproval: this.user
                ? this.isApproval(item, this.user.id)
                : false,
            }))
          console.log(this.approvalList)

          if (tmpArr.length < 10) {
            this.showApprovaBottom = true
            this.approvaFinished = true
          } else {
            this.showApprovaBottom = false
          }
          break
        case 'pre':
          this.prePage = 1
          break
        case 'in':
          this.inPage = 1
          break
        case 'completed':
          this.comPage = 1
          this.startDate &&
            (startTime = dayjs(this.startDate).format('YYYY-MM-DD'))
          this.endDate && (endTime = dayjs(this.endDate).format('YYYY-MM-DD'))
          break
        case 'cancel':
          this.canPage = 1
          break
      }
      if (this.activeName !== 'approval') {
        const res = await queryVisit({
          companyId: this.user.companyId,
          staffId: this.user.id,
          status: this.activeName,
          page: 1,
          pageSize: 10,
          endTime,
          startTime,
        })
        let tmpArr = res.results
        switch (this.activeName) {
          case 'pre':
            this.preList = []
            this.preList = [...tmpArr]
            if (tmpArr.length < 10) {
              this.showPreBottom = true
              this.preFinished = true
            } else {
              this.showPreBottom = false
            }
            break
          case 'in':
            this.inList = []
            this.inList = [...tmpArr]
            if (tmpArr.length < 10) {
              this.showInBottom = true
              this.inFinished = true
            } else {
              this.showInBottom = false
            }
            break
          case 'completed':
            this.completedList = []
            this.completedList = [...tmpArr]
            if (tmpArr.length < 10) {
              this.showComBottom = true
              this.comFinished = true
            } else {
              this.showComBottom = false
            }
            break
          case 'cancel':
            this.cancelList = []
            this.cancelList = [...tmpArr]
            if (tmpArr.length < 10) {
              this.showCanBottom = true
              this.canFinished = true
            } else {
              this.showCanBottom = false
            }
            break
        }
      }
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
    goBack() {
      this.$router.push('/robot')
    },
    async checkRepeat(data) {
      if (this.approvalLoading) return
      try {
        this.approvalLoading = true
        await visitAudit(data)
        this.approvalPage = 1
        const res = await queryVisitAuditData({
          companyId: this.user.companyId,
          staffId: this.user.id,
          page: 1,
          pageSize: 10,
        })
        let tmpArr = res.results
        this.approvalList = []
        this.approvalList =
          [...tmpArr] &&
          [...tmpArr].map((item) => ({
            ...item,
            isApproval: this.user ? this.isApproval(item, this.user.id) : false,
          }))
        if (tmpArr.length < 10) {
          this.showApprovaBottom = true
          this.approvaFinished = true
        } else {
          this.showApprovaBottom = false
        }

        Toast(this.$t('审批已通过'))
      } catch (error) {
        console.error(error)
        Toast(this.$t('审批失败，请重试'))
      } finally {
        this.approvalLoading = false
      }
    },

    async onRefuse(data) {
      if (this.approvalLoading) return
      try {
        this.approvalLoading = true
        await visitAudit(data)
        this.approvalPage = 1
        const res = await queryVisitAuditData({
          companyId: this.user.companyId,
          staffId: this.user.id,
          page: 1,
          pageSize: 10,
        })
        let tmpArr = res.results
        this.approvalList = []
        this.approvalList =
          [...tmpArr] &&
          [...tmpArr].map((item) => ({
            ...item,
            isApproval: this.user ? this.isApproval(item, this.user.id) : false,
          }))
        if (tmpArr.length < 10) {
          this.showApprovaBottom = true
          this.approvaFinished = true
        } else {
          this.showApprovaBottom = false
        }

        Toast(this.$t('审批已拒绝'))
      } catch (error) {
        console.error(error)
        Toast(this.$t('审批失败，请重试'))
      } finally {
        this.approvalLoading = false
      }
    },
    // 格式化访问时间，优先使用 finishTime
    formatVisitTime(item) {
      if (!item.visitTime) return ''

      const startTime = dayjs(item.visitTime)
      const endTime = item.finishTime
        ? dayjs(item.finishTime)
        : (item.visitEndTime ? dayjs(item.visitEndTime) : null)

      if (!endTime) {
        return startTime.format('YYYY-MM-DD HH:mm')
      }

      // 判断是否跨天
      // const isSameDay = startTime.format('YYYY-MM-DD') === endTime.format('YYYY-MM-DD')

      // if (isSameDay) {
      //   // 同一天，显示格式：YYYY-MM-DD HH:mm-HH:mm
      //   return `${startTime.format('YYYY-MM-DD HH:mm')}-${endTime.format('HH:mm')}`
      // } else {
      //   // 跨天，显示格式：YYYY-MM-DD HH:mm - YYYY-MM-DD HH:mm
      //   return `${startTime.format('YYYY-MM-DD HH:mm')} - ${endTime.format('YYYY-MM-DD HH:mm')}`
      // }
      return `${startTime.format('YYYY-MM-DD HH:mm')} - ${endTime.format('YYYY-MM-DD HH:mm')}`
    },
    // 提前结束访客邀约
    async handleEarlyEnd(id) {
      try {
        await this.$dialog.confirm({
          title: '提示',
          message: '确认要提前结束此访客邀约吗？',
        })

        await visitEndEarly(id)
        Toast.success('已提前结束')

        // 刷新列表
        this.onRefresh()
      } catch (error) {
        if (error !== 'cancel') {
          Toast.fail(error?.response?.data || '操作失败')
        }
      }
    },
  },
  watch: {
    approvalList: {
      handler(newVal, oldVal) {
        this.$forceUpdate()
      },
      deep: true,
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.activeName = this.$store.state.visitorState
    this.height = document.body.scrollHeight - 80
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.visitors {
  height: 100%;
  background: #f6f6f6;
  overflow: hidden;
  .navBar-wrap {
    height: 44px;
    width: 100%;
    background-color: #f2f4f7;
  }
  .timeRangeBox {
    width: 351px;
    height: 40px;
    background: #fefffe;
    border-radius: 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 40px;
    color: #b7bdc6;
    .date-icon {
      width: 24px;
      height: 24px;
      margin-left: 20px;
      margin-right: 12px;
    }
    .swap-icon {
      margin-left: 12px;
      margin-right: 12px;
    }
  }
  .infoBox {
    overflow: auto;
    width: 100%;
  }
}
.bottom {
  display: flex;
  align-items: center;
  padding: 30px 48px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  > div {
    width: 96px;
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
  }
  span {
    padding: 0 22px;
  }
}
.card-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 12px;
  gap: 12px;
}
.list-box {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  flex-direction: column;
}
.tab-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 12px;
}
.empty {
}
.empty-box {
  height: 210px;
  margin-top: 144px;
  box-sizing: border-box;
  justify-content: center;
  .empty-box-img {
    width: 240px;
    height: 180px;
  }
  .empty-box-text {
    width: 240px;
    height: 20px;
    line-height: 20px;
    margin-top: 10px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #646b73;
    font-style: normal;
  }
}
/deep/.van-tabs__line {
  width: 44px;
  height: 3px;
}
/deep/.van-tab {
  background-color: #f5f5f5;
  border-bottom: 1px solid #eaecef;
}
</style>
